module.exports = __webpack_public_path__ + "img/dollar.458c7d6a.png";